module.exports = __webpack_public_path__ + "img/img-3-8.81764242.webp";